import { render, staticRenderFns } from "./DetailMobile.vue?vue&type=template&id=13da6dc1&scoped=true"
import script from "./DetailMobile.vue?vue&type=script&lang=js"
export * from "./DetailMobile.vue?vue&type=script&lang=js"
import style0 from "./DetailMobile.vue?vue&type=style&index=0&id=13da6dc1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13da6dc1",
  null
  
)

export default component.exports